/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/public/js/app.js` file.
 *
 * @package   Tibs
 * @author    Tibor Paulsch <contact@tiborpaulsch.nl>

 */


import ResponsiveMenu from './components/responsive-menu.js';
import './components/sticky-nav';
import './components/searchbox';
import './components/logo-swiper';
import './components/systems-swiper';
import './components/about-swiper';
import './components/system-swiper';
import './components/timeline';
import './components/hero-scroll';
import './components/hero-swiper';
import './components/accordion';
// Setup a new menu
const menu = new ResponsiveMenu( 'primary-menu', { animateToggle: true });
